import { THeader } from '../Header/types'
import { FeedProps } from '../TimelineFeed/types'
import { PrivacyOptionsVariant, TPostForm } from '../../PostForm/types'

export const redButton = 'text-red-500 hover:text-red-500'

export type TFeedActionsMenu = Pick<THeader, 'feed'> & {
  isAuthor: boolean
  canPinPost?: boolean
  isVisiblePinAction?: boolean
  privacyOptionsVariant?: PrivacyOptionsVariant
  renderFeed?: (props: FeedProps) => JSX.Element
  renderEditModal?: (props: TPostForm) => JSX.Element
}
